import '@toast-ui/chart/dist/toastui-chart.min.css';
import React from 'react';
import {ColumnLineChart} from '@toast-ui/react-chart'
import analytics from 'utils/analytics';
import Icon from 'components/Icon';

export default class ImpressionsChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            gotData: false,
            data: {},
            groupBy:'day'
        }
    }

    async componentDidMount() {
        const { project, startDate, endDate } = this.props;
        if (project && project.id) {
            await this.fetchStats(project, startDate, endDate );
        }
    }

    async shouldComponentUpdate(nextProps, nextState){
        const { project, startDate, endDate } = this.props;
        if(startDate !== nextProps.startDate || endDate !== nextProps.endDate) {
            await this.fetchStats(project, nextProps.startDate, nextProps.endDate );
        }
    }

    async fetchStats(project, startDate, endDate ) {
        // 👇 must be an array of queries
        const queries = [
            {
                name: 'impressions',
                collection: 'Impression',
                api: 'Interactr',
                filters: {
                    project_id: project.id
                },
                start_date: startDate,
                end_date: endDate,
                group_by: 'day'
            },
            {
                name: 'plays',
                collection: 'ProjectView',
                api: 'Interactr',
                filters: {
                    project_id: project.id
                },
                start_date: startDate,
                end_date: endDate,
                group_by: 'day'
            }
        ];

        // Keep pushing queries as needed

        try {
            const { data } = await analytics.queries(queries);
            console.log(data);
            this.setState({ data, gotData: true });

        } catch (error) {
            this.setState({ fetchingStats: false, statsErrors: { views: true } });
        }
    }

    getData(){
        const {data, groupBy} = this.state;

        const impressions = analytics.getSeriesFromQuery(data.impressions);
        const plays = analytics.getSeriesFromQuery(data.plays);
        const playRate = this.getPlayRate(impressions, plays);

        return {
          categories: analytics.getCategoriesFromQuery(data.impressions, groupBy),
          series: {
              column: [
                  {
                      name: 'Impressions',
                      data: impressions
                  },{
                      name: 'Plays',
                      data: plays
                  }
              ],
              line: [
                  {
                      name: 'Play Rate (%)',
                      data: playRate
                  }
              ]
          }
        };
    }

    getPlayRate(impressions, plays){
        return impressions.map((value, index)=>{
            const percent = (plays[index] / value) * 100;
            // Round to 2 dp
            const val =  Math.round(percent * 100) / 100
            return (isNaN(val)) ? 0.00 : (val > 100) ? 100 : val;
        })
    }

    render(){
        const {gotData} = this.state;

        if(! gotData){
            return(
                <p><Icon spin name="circle-notch" /> Getting Chart Data</p>
            );
        }

        const data = this.getData();

        const options = {
            chart: {
                width: 1160,
                height: 540,
                //title: '24-hr Average Temperature'
            },
            yAxis: [{
                title: 'Impressions',
                chartType: 'column',
                labelMargin: 15
            }, {
                title: 'Play Rate (%)',
                chartType: 'line',
                labelMargin: 15,
                max: 100
            }],
            xAxis: {
                title: 'Month'
            },
            series: {
                line: {
                    showDot: true
                }
            },
            tooltip: {
                grouped: true,
                //suffix: '°C'
            },
            theme: 'myTheme'
        };


        return(
            <div>
                {/*<div>*/}
                {/*    <h2 style={{marginTop: 0}}>Project Impressions</h2>*/}
                {/*    <p>Each time the project is loaded on a page this counts as an impression.</p>*/}
                {/*</div>*/}
                <div>
                    { data &&
                        <ColumnLineChart
                            data={data}
                            options={options}
                        />
                    }
                </div>
            </div>
        );
    }

}